import { useState } from "react";
import { CellBox } from "./CellBox";
import { InlineTextEditor } from "../InlineTextEditor";

export type DescriptionCellProps = {
  value: string;
  /// Shown dimmed when `value` is empty — the transaction's merchant.
  placeholder: string;
  pending: boolean;
  onCommit: (value: string) => void;
};

/**
 * The description cell owns its "editing" flag, so clicking into a row's
 * description re-renders this cell alone, and the editor (which holds the
 * draft locally) is ready for keystrokes in the same frame.
 */
export const DescriptionCell = ({
  value,
  placeholder,
  pending,
  onCommit,
}: DescriptionCellProps) => {
  const [editing, setEditing] = useState(false);

  if (editing) {
    return (
      <InlineTextEditor
        aria-label="Description"
        initialValue={value}
        placeholder={placeholder}
        onCommit={onCommit}
        onClose={() => setEditing(false)}
      />
    );
  }

  const isPlaceholder = !value;
  return (
    <CellBox
      pending={pending}
      onClick={() => setEditing(true)}
      sx={{
        // Secondary, not disabled: a merchant standing in for an unwritten
        // description is still the row's content, and must stay above the
        // counterparty marker beside it in both light and dark mode.
        color: isPlaceholder ? "text.secondary" : "inherit",
        fontStyle: isPlaceholder ? "italic" : "inherit",
      }}
    >
      {isPlaceholder ? placeholder : value}
    </CellBox>
  );
};
